import { ConfigOptions } from 'export-to-csv';

/** Semicolon-separated UTF-8 with BOM, so German Excel opens it with umlauts and columns intact. */
export const contestEntriesCsvConfig = (
    from: string,
    to: string
): ConfigOptions => ({
    filename: `gewinnspiel-${from}-bis-${to}`,
    fileExtension: 'csv',
    fieldSeparator: ';',
    useBom: true,
    useKeysAsHeaders: true,
});

// The contest runs in Austria: the date column shows Vienna time, whatever the browser's zone.
const viennaDateTime = new Intl.DateTimeFormat('de-AT', {
    timeZone: 'Europe/Vienna',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
});

/** dd.MM.yyyy HH:mm in Europe/Vienna. */
export const formatViennaDateTime = (date: Date) => {
    const part = Object.fromEntries(
        viennaDateTime
            .formatToParts(date)
            .map(({ type, value }) => [type, value])
    );
    return `${part.day}.${part.month}.${part.year} ${part.hour}:${part.minute}`;
};

type CsvEntry = {
    createdAt: Date;
    code: string;
    firstname: string;
    lastname: string;
    email: string;
};

// Codes and names are free customer input: a leading =, +, -, @, tab or CR would
// make Excel evaluate the cell as a formula (CSV injection).
const FORMULA_START = /^[=+\-@\t\r]/;

export const neutralizeFormula = (value: string) =>
    FORMULA_START.test(value) ? `'${value}` : value;

export const toContestEntryCsvRows = (entries: CsvEntry[]) =>
    entries.map((entry) => ({
        Datum: formatViennaDateTime(entry.createdAt),
        Code: neutralizeFormula(entry.code),
        Vorname: neutralizeFormula(entry.firstname),
        Nachname: neutralizeFormula(entry.lastname),
        'E-Mail': neutralizeFormula(entry.email),
    }));
